module.exports = __webpack_public_path__ + "img/114ne.4bca738a.svg";